/* globals $ */
'use strict';

const {
  calculatePayout,
  roundToSignificantDigits,
  getSavingsFromProgress,
  ranges,
} = require('../../lib/pension');

let debounceTimeout;

/**
 * Number.prototype.format(numberOfDecimals, groupSeparator)
 *
 * @param integer numberOfDecimals: length of decimal
 * @param string [thousandSeparator=<non-breaking space>]: character(s) to separate thousands
 */
Number.prototype.format = function (numberOfDecimals, thousandSeparator = ' ') {
  return this.toLocaleString('sv-SE', {
    minimumFractionDigits: numberOfDecimals,
    maximumFractionDigits: numberOfDecimals,
  }).replaceAll(' ', thousandSeparator); // non-breaking space -> `thousandSeparator`
};

$.extend($.easing, {
  easeInOutQuint: function (x, t, b, c, d) {
    if ((t /= d / 2) < 1) {
      return (c / 2) * t * t * t * t * t + b;
    }
    return (c / 2) * ((t -= 2) * t * t * t * t + 2) + b;
  },
});

$(function () {
  $('html').css('background-color', $('body').css('background-color'));

  const root = $('.pension');
  const $video = $('#hero-video-element');
  const $videoToggle = $('.video-hero__video-toggle');
  const $mistakeSwitch = $('#common-mistakes .show-more__button');
  const $mistakeCardWrapper = $('#common-mistakes .diagram__card')
    .first()
    .parent();
  const $testimonialCarousel = $('#testimonial-carousel');
  const $faqToggles = $('.faq__summary');
  const videoEl = $video.get(0);

  // Respect user's "prefers-reduced-motion" setting: pause video by default if true.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    videoEl.pause();
    $videoToggle.attr('aria-checked', 'false');
    $videoToggle.addClass('paused');
    $videoToggle.attr('aria-label', 'Play video');
  }

  // Toggle video play/pause
  $videoToggle.on('click', function () {
    if (videoEl.paused) {
      videoEl.play();
      $videoToggle.removeClass('paused');
      $videoToggle.attr('aria-checked', 'true');
      $videoToggle.attr('aria-label', 'Pause video');
    } else {
      videoEl.pause();
      $videoToggle.attr('aria-checked', 'false');
      $videoToggle.addClass('paused');
      $videoToggle.attr('aria-label', 'Play video');
    }
  });

  // Diagrams: Toggle detailed explanation
  $mistakeSwitch.on('click', function () {
    $mistakeCardWrapper.toggleClass('extended');
    $mistakeSwitch.toggleClass('on');
  });

  // FAQ: Delay toggle close to support height transition
  $faqToggles.on('click', function (event) {
    const $faqDetails = $(this).parent();
    if (
      $faqDetails.attr('open') &&
      !$faqDetails.hasClass('closing') &&
      event.originalEvent
    ) {
      event.preventDefault();

      const $faqSummary = $faqDetails.find('summary');

      $faqDetails.addClass('closing');
      setTimeout(() => {
        $faqDetails.removeClass('closing');
        $faqSummary.click();
      }, 300);
    }
  });

  // Offset testimonial horizontal scroll before scroll-into-view
  $testimonialCarousel.get(0).scroll(600, 0);

  // Scroll-into-view animation
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');

        if (entry.target.id === 'testimonial-carousel') {
          // Testimonial horizontal scroll on scroll-into-view
          entry.target.scroll({
            left: 32,
            behavior: 'smooth',
          });
        } else if (entry.target.classList.contains('space-pusher')) {
          // How-it-works transition triggered by different element
          // where CSS can't traverse alone
          entry.target.parentNode.parentNode.classList.add('in-view');
        } else if (entry.target.classList.contains('pension-calculator')) {
          const ageRanger = root.find('#age-ranger-input');
          const savingsRanger = root.find('#savings-ranger-input');
          savingsRanger.val(0).change();
          savingsRanger.animate(
            {
              value: 0.3,
            },
            {
              duration: 1400,
              easing: 'easeInOutQuint',
              step: function () {
                savingsRanger.change();
              },
            },
          );
          ageRanger.val(0).change();
          ageRanger.animate(
            {
              value: 32,
            },
            {
              duration: 1400,
              easing: 'easeInOutQuint',
              step: function () {
                ageRanger.change();
              },
            },
          );
        }

        obs.unobserve(entry.target);
      }
    });
  });
  document.querySelectorAll('.appear-container').forEach((el) => {
    observer.observe(el);
  });

  // Transition while scrolling away from top
  const videoHeroContainer = document.querySelector('header.video-hero');
  window.addEventListener('scroll', applyVideoHeroBorderRadius);
  applyVideoHeroBorderRadius();
  function applyVideoHeroBorderRadius() {
    // Within third of screen height
    const scrollToTransitionPoint = (3 * window.scrollY) / window.innerHeight;

    // Apply if not out of sight
    if (scrollToTransitionPoint < 3) {
      const transitionProgress = Math.min(scrollToTransitionPoint, 1);
      videoHeroContainer.style.setProperty(
        '--bottom-border-radius',
        transitionProgress,
      );
    }
  }

  // Increase click area that selects the slider
  // (label element clicks put focus on input by default)
  const sliderAreas = root.find('.calculator__input-value-row');
  sliderAreas.on('click', function () {
    this.parentNode.querySelector('input').focus();
  });

  // Slider input/output sync
  const ageMin = 18;
  const ageMax = 67;
  const savingsMin = 0;
  const savingsMax = 10_000_000;

  const ageRanger = root.find('#age-ranger-input');
  ageRanger.attr('aria-valuemin', ageMin);
  ageRanger.attr('aria-valuemax', ageMax);
  ageRanger.on('input change', onSliderChange);

  const savingsRanger = root.find('#savings-ranger-input');
  savingsRanger.attr('aria-valuemin', savingsMin);
  savingsRanger.attr('aria-valuemax', savingsMax);
  savingsRanger.on('input change', onSliderChange);

  const stepSizeValues = {
    LOW: 1_000,
    MEDIUM: 10_000,
    HIGH: 100_000,
  };
  const stepSizes = {
    // slider range span / (savings range span / savings step size)
    LOW: ranges.LOW.slider / (ranges.LOW.savings / stepSizeValues.LOW),
    MEDIUM:
      ranges.MEDIUM.slider / (ranges.MEDIUM.savings / stepSizeValues.MEDIUM),
    HIGH: ranges.HIGH.slider / (ranges.HIGH.savings / stepSizeValues.HIGH),
  };

  let previousSavingsRange = 'LOW';

  function getRangeFromProgress(progress) {
    return progress < 0.3 ? 'LOW' : progress <= 0.9 ? 'MEDIUM' : 'HIGH';
  }

  function templateFeeToAllocationFee(templateFee) {
    return {
      administrativeFeeVariable: {
        fee: templateFee.insurance.fee,
      },
      administrativeFeeFixed: {
        fee: { amount: 0 },
      },
      ongoingCharge: {
        fee: templateFee['target-instruments']['ongoing-charge'],
      },
      netTrailerFee: {
        fee: templateFee['target-instruments']['net-trailer-fee'] * -1,
      },
      managementFee: {
        fee: templateFee['ongoing-charge'],
      },
      managementFeeDiscount: {
        fee: 0,
      },
      securitiesAccountFee: {
        fee: templateFee['securities-account'].fee,
      },
    };
  }

  function onSliderChange(e) {
    e.preventDefault();
    // Refresh age value
    const ageRanger = root.find('#age-ranger-input');
    const ageValue = root.find('#age-ranger-value');
    const ageProgress = (ageRanger.get(0).value - ageMin) / (ageMax - ageMin);
    ageRanger.attr(
      'style',
      '--progress: ' + Math.floor(ageProgress * 100) + '%',
    );
    const age = Math.round(ageRanger.get(0).value);
    ageValue.html(age);
    ageRanger.attr('value', age);
    ageRanger.attr('aria-valuenow', age);
    ageRanger.attr('aria-valuetext', `${age} år`);

    // Refresh savings value
    const savingsRanger = root.find('#savings-ranger-input');
    const savingsValue = root.find('#savings-ranger-value');
    const savingsProgress = savingsRanger.get(0).value;

    savingsRanger.attr(
      'style',
      '--progress: ' + Math.round(savingsProgress * 100) + '%',
    );

    const savings = getSavingsFromProgress(savingsProgress);

    savingsRanger.attr(
      'step',
      stepSizes[getRangeFromProgress(savingsProgress)],
    );

    // Refresh savings input
    savingsValue.html(savings.format(0, ' '));

    // Prepare output refresh
    const outputContainer = root.find('.calculator__output-section');
    const output = outputContainer.find('.calculator__output-value');
    const outputMonthly = outputContainer.find(
      '.calculator__output-value-monthly',
    );

    // Start next month
    let date = new Date();
    date.setMonth(date.getMonth() + 1);
    date = new Date(date.getFullYear(), date.getMonth(), 1);

    const yearsUntilPension = 67 - age;
    const yearsOfPayouts = 15;
    const yearsWithLowerRisk = 6;

    const startDate = new Date();

    const highRiskEndDate = new Date();
    highRiskEndDate.setFullYear(
      highRiskEndDate.getFullYear() +
        yearsUntilPension +
        yearsOfPayouts -
        yearsWithLowerRisk,
    );

    const endDate = new Date();
    endDate.setFullYear(
      endDate.getFullYear() + yearsUntilPension + yearsOfPayouts,
    );

    // `pensionFees` is injected in `index.hbs`
    // eslint-disable-next-line no-undef
    const fees = pensionFees;

    const pensionResult = calculatePayout({
      currentAmount: savings,
      monthsUntilPension: 12 * yearsUntilPension,
      payoutPeriodInMonths: 12 * yearsOfPayouts,
      currentDate: new Date(date),
      allocations: [
        {
          name: 'Opti 100% aktier',
          fees: templateFeeToAllocationFee(fees['MAX_RETURN_NO_COMMODITIES']),
          returns: {
            total: 0.099,
          },
          fromDate: startDate,
          toDate: highRiskEndDate,
        },
        {
          name: 'Opti 9',
          fees: templateFeeToAllocationFee(fees['RISK_LEVEL_9']),
          returns: {
            total: 0.08845,
          },
          fromDate: highRiskEndDate,
          toDate: endDate,
        },
      ],
    });

    // Round value to give the user a rough idea of magnitude
    const significantDigits = 3;
    const pensionRounded = roundToSignificantDigits(
      pensionResult,
      significantDigits,
    );
    const pensionMonthlyRounded = roundToSignificantDigits(
      pensionResult / (15 * 12),
      significantDigits,
    );

    // Set new projected pension
    output.each(function () {
      $(this).html(pensionRounded.format(0, ' <wbr />')); // add whitespace
      const outputSuffix = $(this).parent().find('.calculator__output-suffix');
      outputSuffix.text('kr');
    });

    outputMonthly.each(function () {
      $(this).html(pensionMonthlyRounded.format(0, '&thinsp;<wbr />')); // add thin-space and word-break
      const outputMonthlySuffix = $(this).next();
      outputMonthlySuffix.text('kr');
      $(this).parent().prev().text('eller');
      $(this).parent().next().text('per månad');
    });

    // Prevent screen readers to speak every intermediate value, while user is interacting with slider
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => {
      // Manage step size
      const newSavingsRange = getRangeFromProgress(savingsProgress);
      const newStepSize =
        newSavingsRange !== previousSavingsRange
          ? `, stegstorlek ${stepSizeValues[newSavingsRange]} kronor`
          : '';
      newStepSize && savingsRanger.attr('step', stepSizes[newSavingsRange]);
      previousSavingsRange = newSavingsRange;
      savingsRanger.attr('aria-valuenow', savings);
      savingsRanger.attr('aria-valuetext', `${savings} kronor${newStepSize}`);

      // Update output live region
      const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      const a11yFriendlyOutput = outputContainer.find(
        `#output-section-a11y-friendly-${isDesktop ? 'second' : 'first'}`,
      );
      a11yFriendlyOutput.text(
        `Förväntad pension, ${pensionRounded} kronor, eller ${pensionMonthlyRounded} kronor per månad *`,
      );
    }, 200);
  }

  const carousel = $('#testimonial-carousel');
  let isMouseDown = false;
  let startX;
  let lastX;
  let scrollLeft;
  let momentum = 0;
  let lastTime = null;
  const friction = 0.965;

  carousel.on('mousedown', (e) => {
    isMouseDown = true;
    carousel.addClass('active');

    startX = e.clientX - carousel.get(0).offsetLeft;
    scrollLeft = carousel.get(0).scrollLeft;
  });

  carousel.on('mouseleave', () => {
    isMouseDown = false;
    carousel.removeClass('active');
    animateCarousel();
  });

  carousel.on('mouseup', () => {
    isMouseDown = false;
    carousel.removeClass('active');
    animateCarousel();
  });

  carousel.on('mousemove', (e) => {
    if (!isMouseDown) {
      return;
    }
    e.preventDefault();

    const currentTime = performance.now();
    if (lastTime !== null) {
      const deltaTime = currentTime - lastTime; // time difference in ms
      // Calculate differences in position
      const deltaX = e.clientX - lastX;

      // Compute the velocity in pixels per millisecond
      momentum = deltaX / deltaTime;
    }

    // Update last known values
    lastX = e.clientX;
    lastTime = currentTime;

    // update scroll
    const x = e.pageX - carousel.get(0).offsetLeft;
    const walk = x - startX;
    carousel.get(0).scrollLeft = scrollLeft - walk;
  });

  // Continue scrolling with momentum using friction:
  function animateCarousel() {
    if (Math.abs(momentum) > 0.01) {
      carousel.get(0).scrollLeft -= momentum * 16; // multiplying by ~16 as nominal frame time in ms

      momentum *= friction;
      requestAnimationFrame(animateCarousel);
    } else {
      momentum = 0;
    }
  }
});
